import React, { useState, useMemo, useEffect } from "react";
import { IoIosArrowDropdown } from "react-icons/io";
import { RiResetLeftLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Loading from "../../Extra/Loading";
import {
  getCurrentDate,
  getCurrentFY,
  getCurrentMonthFirstDate,
  getFinancialYearMonthsPassed,
  getLastDateOfFY,
} from "../../Utilitie";
import { BiSolidReport } from "react-icons/bi";
import axios from "axios";

const monthsRef = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

const BlockController = ({ setFilteredData, openStates, setOpenStates }) => {
  const [filteredBlocks, setFilteredBlocks] = useState(null);
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // /////////////////////////////FETCH /////////////////////////////////
  const fetchFilteredData = async () => {
    try {
      const response = await axios.get(
        // `${urlPrefixBlock}getblockcompileddatafiltered`,
        `${urlPrefixBlock}getblockcompileddataDayWise`,

        filteredBlocks,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setFilteredData(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      return null;
    }
  };
  useEffect(() => {
    fetchFilteredData();
  }, []);

  // State for search inputs

  const [searchValues, setSearchValues] = useState({
    Section: "",
    "From Station": "",
    "To Station": "",
    Department: "",
    Type: "",
    "Block Type": "",
    "Granted/Not": "",
    "Availed/Not": "",
    Burst: "",
    Corridor: "",
    Direction: "",
    Month: "",
  });

  // State for selected filters
  const [selectedSections, setSelectedSections] = useState(new Set());
  const [selectedFromStations, setSelectedFromStations] = useState(new Set());
  const [selectedToStations, setSelectedToStations] = useState(new Set());
  const [selectedDepartments, setSelectedDepartments] = useState(new Set());
  const [selectedTypes, setSelectedTypes] = useState(new Set());
  const [selectedBlockTypes, setSelectedBlockTypes] = useState(new Set());
  const [selectedGrantedNot, setSelectedGrantedNot] = useState(new Set());
  const [selectedAvailedNot, setSelectedAvailedNot] = useState(new Set());
  const [selectedBurst, setSelectedBurst] = useState(new Set());
  const [selectedCorridor, setSelectedCorridor] = useState(new Set());
  const [selectedDirection, setSelectedDirection] = useState(new Set());
  const [selectedMonths, setSelectedMonths] = useState(new Set());

  // ////////////////////////////////////////////////////////////////////////////////////////////
  // ///////////////////////////////////Fetch Data//////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////////////////
  const fetchData = async () => {
    setLoading(true);
    const url = `${urlPrefixBlock}getblockcompileddata?end=${endDate}&start=${startDate}`;

    try {
      const response = await axios.get(url);
      const result = response.data;

      if (result.status === "ok") {
        const raw = result.data;

        setData(raw);
      }
      setLoading(false);
    } catch (error) {
      console.error("Axios fetch error:", error);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (endDate) {
      fetchData();
    }
  }, []);

  const handleApiCall = () => {
    fetchData();
    fetchFilteredData();
  };
  const toggleSelection = (
    setFunc,
    currentSet,
    value,
    dependentSetFuncs = []
  ) => {
    const newSet = new Set(currentSet);
    const isAdding = !newSet.has(value);
    if (isAdding) {
      newSet.add(value);
    } else {
      newSet.delete(value);
    }
    setFunc(newSet);

    // Handle dependent selections
    if (dependentSetFuncs.length > 0) {
      dependentSetFuncs.forEach(({ setFunc, getValidOptions }) => {
        const validOptions = getValidOptions(newSet);
        setFunc((prev) => {
          const newDepSet = new Set(prev);
          if (isAdding) {
            // Add all valid dependent options when parent is checked
            validOptions.forEach((opt) => newDepSet.add(opt));
          } else {
            // Remove invalid dependent options when parent is unchecked
            [...newDepSet].forEach((opt) => {
              if (!validOptions.has(opt)) newDepSet.delete(opt);
            });
          }
          return newDepSet;
        });
      });
    }
  };

  const toggleDropdown = (title) => {
    setOpenStates((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleSearchChange = (title, value) => {
    setSearchValues((prev) => ({
      ...prev,
      [title]: value,
    }));
  };

  // Available options for dropdowns
  const availableSections = useMemo(
    () => [...new Set(data?.section || [])],
    [data]
  );

  const availableFromStations = useMemo(() => {
    if (selectedSections.size === 0) return [];
    return [
      ...new Set(
        data?.From_Station.filter((fs) =>
          selectedSections.has(fs.section)
        ).flatMap((fs) => fs.data) || []
      ),
    ];
  }, [data, selectedSections]);

  const availableToStations = useMemo(() => {
    if (selectedSections.size === 0) return [];
    return [
      ...new Set(
        data?.To_Station.filter((ts) =>
          selectedSections.has(ts.section)
        ).flatMap((ts) => ts.data) || []
      ),
    ];
  }, [data, selectedSections]);

  const availableDepartments = useMemo(
    () => [...new Set(data?.Department.filter((d) => d !== null) || [])],
    [data]
  );

  const availableTypes = useMemo(() => {
    if (selectedDepartments.size === 0) return [];
    return [
      ...new Set(
        data?.Type.filter((t) => selectedDepartments.has(t.Department)).flatMap(
          (t) => t.data
        ) || []
      ),
    ];
  }, [data, selectedDepartments]);

  const availableBlockTypes = useMemo(() => {
    if (selectedTypes.size === 0) return [];
    return [
      ...new Set(
        data?.Block_Type.filter(
          (bt) => selectedTypes.has(bt.Block_type) || bt.Block_type === ""
        ).flatMap((bt) => bt.Data) || []
      ),
    ];
  }, [data, selectedTypes]);

  const availableGrantedNot = useMemo(
    () => [...new Set(data?.Granted_Not.filter((gn) => gn !== null) || [])],
    [data]
  );

  const availableAvailedNot = useMemo(
    () => [...new Set(data?.Availed_Not.filter((an) => an !== null) || [])],
    [data]
  );

  const availableBurst = useMemo(
    () => [...new Set(data?.Burst.filter((b) => b !== null) || [])],
    [data]
  );

  const availableCorridor = useMemo(
    () => [...new Set(data?.Corridore.filter((c) => c !== null) || [])],
    [data]
  );
  const availableDirection = useMemo(
    () => [...new Set(data?.Direction.filter((d) => d !== null) || [])],
    [data]
  );

  const availableMonths = useMemo(
    () =>
      data &&
      [...new Set(data?.Month || [])].sort(
        (a, b) => monthsRef?.indexOf(a) - monthsRef?.indexOf(b)
      ),
    [data]
  );
  // Update dependent selections when parent filters change
  useEffect(() => {
    if (selectedSections.size === 0) {
      setSelectedFromStations(new Set());
      setSelectedToStations(new Set());
    } else {
      const validFromStations = new Set(
        data?.From_Station.filter((fs) =>
          selectedSections.has(fs.section)
        ).flatMap((fs) => fs.data)
      );
      const validToStations = new Set(
        data?.To_Station.filter((ts) =>
          selectedSections.has(ts.section)
        ).flatMap((ts) => ts.data)
      );
      setSelectedFromStations((prev) => {
        const newSet = new Set(prev);
        [...newSet].forEach((station) => {
          if (!validFromStations.has(station)) newSet.delete(station);
        });
        validFromStations.forEach((station) => newSet.add(station));
        return newSet;
      });
      setSelectedToStations((prev) => {
        const newSet = new Set(prev);
        [...newSet].forEach((station) => {
          if (!validToStations.has(station)) newSet.delete(station);
        });
        validToStations.forEach((station) => newSet.add(station));
        return newSet;
      });
    }
  }, [data, selectedSections]);

  useEffect(() => {
    if (selectedDepartments.size === 0) {
      setSelectedTypes(new Set());
    } else {
      const validTypes = new Set(
        data?.Type.filter((t) => selectedDepartments.has(t.Department)).flatMap(
          (t) => t.data
        )
      );
      setSelectedTypes((prev) => {
        const newSet = new Set(prev);
        [...newSet].forEach((type) => {
          if (!validTypes.has(type)) newSet.delete(type);
        });
        validTypes.forEach((type) => newSet.add(type));
        return newSet;
      });
    }
  }, [data, selectedDepartments]);

  useEffect(() => {
    if (selectedTypes.size === 0) {
      setSelectedBlockTypes(new Set());
    } else {
      const validBlockTypes = new Set(
        data?.Block_Type.filter(
          (bt) => selectedTypes.has(bt.Block_type) || bt.Block_type === ""
        ).flatMap((bt) => bt.Data)
      );
      setSelectedBlockTypes((prev) => {
        const newSet = new Set(prev);
        [...newSet].forEach((block) => {
          if (!validBlockTypes.has(block)) newSet.delete(block);
        });
        validBlockTypes.forEach((block) => newSet.add(block));
        return newSet;
      });
    }
  }, [data, selectedTypes]);

  const filteredData = useMemo(() => {
    if (!data) return [];

    // Section
    const allSections = new Set(data.section || []);
    const sectionOutput =
      selectedSections.size === allSections.size && allSections.size > 0
        ? ["All"]
        : [...selectedSections];

    // From Station
    const allFromStations = new Set(
      data.From_Station.flatMap((fs) => fs.data) || []
    );
    let fromStationData = data.From_Station.map((fs) => ({
      ...fs,
      data: fs.data.filter(
        (station) =>
          (selectedSections.size === 0 || selectedSections.has(fs.section)) &&
          (selectedFromStations.size === 0 || selectedFromStations.has(station))
      ),
    })).filter((fs) => fs.data.length > 0 || selectedSections.size === 0);
    const fromStationOutput =
      selectedFromStations.size === allFromStations.size &&
      selectedSections.size > 0
        ? ["All"]
        : fromStationData;

    // To Station
    const allToStations = new Set(
      data.To_Station.flatMap((ts) => ts.data) || []
    );
    let toStationData = data.To_Station.map((ts) => ({
      ...ts,
      data: ts.data.filter(
        (station) =>
          (selectedSections.size === 0 || selectedSections.has(ts.section)) &&
          (selectedToStations.size === 0 || selectedToStations.has(station))
      ),
    })).filter((ts) => ts.data.length > 0 || selectedSections.size === 0);
    const toStationOutput =
      selectedToStations.size === allToStations.size &&
      selectedSections.size > 0
        ? ["All"]
        : toStationData;

    // Department
    const allDepartments = new Set(
      data.Department.filter((d) => d !== null) || []
    );
    const departmentOutput =
      selectedDepartments.size === allDepartments.size &&
      allDepartments.size > 0
        ? ["All"]
        : data.Department.filter(
            (dept) =>
              dept === null ||
              selectedDepartments.size === 0 ||
              selectedDepartments.has(dept)
          );

    // Type
    const allTypes = new Set(data.Type.flatMap((t) => t.data) || []);
    let typeData = data.Type.map((t) => ({
      ...t,
      data: t.data.filter(
        (type) =>
          (selectedDepartments.size === 0 ||
            selectedDepartments.has(t.Department)) &&
          (selectedTypes.size === 0 || selectedTypes.has(type))
      ),
    })).filter((t) => t.data.length > 0 || selectedDepartments.size === 0);
    const typeOutput =
      selectedTypes.size === allTypes.size && selectedDepartments.size > 0
        ? ["All"]
        : typeData;

    // Block Type
    const allBlockTypes = new Set(
      data.Block_Type.flatMap((bt) => bt.Data) || []
    );
    let blockTypeData = data.Block_Type.map((bt) => ({
      ...bt,
      Data: bt.Data.filter(
        (block) =>
          (selectedTypes.size === 0 ||
            selectedTypes.has(bt.Block_type) ||
            bt.Block_type === "") &&
          (selectedBlockTypes.size === 0 || selectedBlockTypes.has(block))
      ),
    })).filter((bt) => bt.Data.length > 0 || selectedTypes.size === 0);
    const blockTypeOutput =
      selectedBlockTypes.size === allBlockTypes.size && selectedTypes.size > 0
        ? ["All"]
        : blockTypeData;

    // Granted/Not
    const allGrantedNot = new Set(
      data.Granted_Not.filter((gn) => gn !== null) || []
    );
    const grantedNotOutput =
      selectedGrantedNot.size === allGrantedNot.size && allGrantedNot.size > 0
        ? ["All"]
        : data.Granted_Not.filter(
            (gn) =>
              gn === null ||
              selectedGrantedNot.size === 0 ||
              selectedGrantedNot.has(gn)
          );

    // Availed/Not
    const allAvailedNot = new Set(
      data.Availed_Not.filter((an) => an !== null) || []
    );
    const availedNotOutput =
      selectedAvailedNot.size === allAvailedNot.size && allAvailedNot.size > 0
        ? ["All"]
        : data.Availed_Not.filter(
            (an) =>
              an === null ||
              selectedAvailedNot.size === 0 ||
              selectedAvailedNot.has(an)
          );

    // Burst
    const allBurst = new Set(data.Burst.filter((b) => b !== null) || []);
    const burstOutput =
      selectedBurst.size === allBurst.size && allBurst.size > 0
        ? ["All"]
        : data.Burst.filter(
            (b) =>
              b === null || selectedBurst.size === 0 || selectedBurst.has(b)
          );

    // Corridor
    const allCorridor = new Set(data.Corridore.filter((c) => c !== null) || []);
    const corridorOutput =
      selectedCorridor.size === allCorridor.size && allCorridor.size > 0
        ? ["All"]
        : data.Corridore.filter(
            (c) =>
              c === null ||
              selectedCorridor.size === 0 ||
              selectedCorridor.has(c)
          );
    // Direction
    const allDirection = new Set(
      data.Direction.filter((d) => d !== null) || []
    );
    const directionOutput =
      selectedDirection.size === allDirection.size && allDirection.size > 0
        ? ["All"]
        : data.Direction.filter(
            (d) =>
              d === null ||
              selectedDirection.size === 0 ||
              selectedDirection.has(d)
          );
    // Month
    const allMonths = new Set(data.Month || []);
    const monthOutput =
      selectedMonths.size === allMonths.size && allMonths.size > 0
        ? ["All"]
        : data.Month.filter(
            (month) => selectedMonths.size === 0 || selectedMonths.has(month)
          );

    return {
      section: sectionOutput,
      From_Station: fromStationOutput,
      To_Station: toStationOutput,
      Department: departmentOutput,
      Type: typeOutput,
      Block_Type: blockTypeOutput,
      Granted_Not: grantedNotOutput,
      Availed_Not: availedNotOutput,
      Burst: burstOutput,
      Corridor: corridorOutput,
      Direction: directionOutput,
      Month: monthOutput,
    };
  }, [
    data,
    selectedSections,
    selectedFromStations,
    selectedToStations,
    selectedDepartments,
    selectedTypes,
    selectedBlockTypes,
    selectedGrantedNot,
    selectedAvailedNot,
    selectedBurst,
    selectedCorridor,
    selectedDirection,
    selectedMonths,
  ]);

  const defaultSetup = () => {
    if (!data) return;

    setSelectedSections(new Set(data.section));
    setSelectedFromStations(
      new Set(data.From_Station.flatMap((fs) => fs.data))
    );
    setSelectedToStations(new Set(data.To_Station.flatMap((ts) => ts.data)));
    setSelectedDepartments(new Set(data.Department.filter((d) => d !== null)));
    setSelectedTypes(new Set(data.Type.flatMap((t) => t.data)));
    setSelectedBlockTypes(new Set(data.Block_Type.flatMap((bt) => bt.Data)));
    setSelectedGrantedNot(
      new Set(data.Granted_Not.filter((gn) => gn !== null))
    );
    setSelectedAvailedNot(
      new Set(data.Availed_Not.filter((an) => an !== null))
    );
    setSelectedBurst(new Set(data.Burst.filter((b) => b !== null)));
    setSelectedCorridor(new Set(data.Corridore.filter((c) => c !== null)));
    setSelectedDirection(new Set(data.Direction.filter((d) => d !== null)));
    setSelectedMonths(getFinancialYearMonthsPassed(getCurrentFY, false));
    setOpenStates({
      Section: false,
      "From Station": false,
      "To Station": false,
      Department: false,
      Type: false,
      "Block Type": false,
      "Granted/Not": false,
      "Availed/Not": false,
      Burst: false,
      Corridor: false,
      Direction: false,
      Month: false,
    });
  };

  useEffect(() => {
    defaultSetup();
  }, [data]);

  useEffect(() => {
    setFilteredBlocks({ ...filteredData, sata: startDate, end: endDate });
  }, [filteredData, setFilteredBlocks]);

  const renderCheckboxList = (
    title,
    items,
    selectedSet,
    setFunc,
    dependentSetFuncs = []
  ) => {
    const filteredItems = items?.filter((item) =>
      item
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchValues[title]?.toLowerCase())
    );

    return (
      <div className="col-md mt-2 p-1">
        <div
          className="bg-light"
          style={{
            position: "relative",
            fontSize: 12,
            borderRadius: "5px",
          }}
        >
          <div
            className="papaDiv flex items-center justify-between"
            onClick={() => toggleDropdown(title)}
            style={{
              border: "1px solid #ccc",
              padding: "8px",
              cursor: "pointer",
              minWidth: "150px",
              maxHeight: "50px",
              overflow: "hidden",
              userSelect: "none",
            }}
          >
            Select {title}
            <IoIosArrowDropdown
              style={{
                fontSize: 15,
                transition: "transform 0.3s ease",
                transform: openStates[title]
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            />
          </div>
          {openStates[title] && (
            <div
              className="papaDiv text-start"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #ccc",
                background: "#fff",
                zIndex: 10,
              }}
            >
              <strong>{title}</strong>
              <input
                style={{ height: "25px", width: "90%" }}
                className="form-control ms-2 mb-1 me-2"
                type="search"
                placeholder={`Search ${title}...`}
                aria-label={`Search ${title}`}
                value={searchValues[title]}
                onChange={(e) => handleSearchChange(title, e.target.value)}
              />
              <hr className="m-0 p-0" />
              <div
                className="flex flex-wrap mt-1"
                style={{
                  maxHeight: "200px",
                  minHeight: "50px",
                  overflowY: "auto",
                }}
              >
                {filteredItems.length > 0 ? (
                  filteredItems.map((item, index) => (
                    <div
                      key={index}
                      className="w-1/3 fade-in"
                      style={{ fontSize: "12px" }}
                    >
                      <label
                        className="ms-1 text-start flex items-center"
                        style={{ cursor: "pointer" }}
                      >
                        <input
                          className="form-check-input mr-1"
                          type="checkbox"
                          checked={selectedSet.has(item)}
                          onChange={() =>
                            toggleSelection(
                              setFunc,
                              selectedSet,
                              item,
                              dependentSetFuncs
                            )
                          }
                        />
                        {item}
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="w-full text-center">No items found</div>
                )}
              </div>
              <hr className="m-0 p-0" />
              <div className="flex justify-evenly mt-1">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    setFunc(new Set(items));
                    dependentSetFuncs.forEach(
                      ({ setFunc, getValidOptions }) => {
                        const validOptions = getValidOptions(new Set(items));
                        setFunc(new Set(validOptions));
                      }
                    );
                  }}
                >
                  Select All
                </button>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => {
                    setFunc(new Set());
                    dependentSetFuncs.forEach(({ setFunc }) =>
                      setFunc(new Set())
                    );
                  }}
                >
                  Clear All
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="papaDiv">
      <div className="row">
        <div className="bg-dark text-white p-1 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="text-center">
              {" "}
              <BiSolidReport /> Block Reports
            </h5>
          </div>
          <div className="d-flex">
            {" "}
            <b>From</b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className=" me-1"
            />
            <b>To</b>
            <input
              type="date"
              value={endDate}
              max={getLastDateOfFY(startDate)}
              min={startDate}
              onChange={(e) => setEndDate(e.target.value)}
              className=" me-1"
            />
            <button
              className=" ms-1 btn btn-sm btn-outline-light"
              onClick={fetchData}
            >
              {" "}
              Fetch
            </button>
          </div>
        </div>
      </div>
      <div
        className="row"
        style={{
          border: "1px solid #ccc",
          background: "rgba(255, 255, 255, 0.22)",
          boxShadow: "5px 5px 20px rgba(7, 7, 7, 0.3)",
          backdropFilter: "blur(15px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      >
        {loading ? <Loading /> : null}
        {renderCheckboxList(
          "Section",
          availableSections,
          selectedSections,
          setSelectedSections,
          [
            {
              setFunc: setSelectedFromStations,
              getValidOptions: (sections) =>
                new Set(
                  data?.From_Station.filter((fs) =>
                    sections.has(fs.section)
                  ).flatMap((fs) => fs.data)
                ),
            },
            {
              setFunc: setSelectedToStations,
              getValidOptions: (sections) =>
                new Set(
                  data?.To_Station.filter((ts) =>
                    sections.has(ts.section)
                  ).flatMap((ts) => ts.data)
                ),
            },
          ]
        )}
        {/* {renderCheckboxList(
          "From Station",
          availableFromStations,
          selectedFromStations,
          setSelectedFromStations
        )}
        {renderCheckboxList(
          "To Station",
          availableToStations,
          selectedToStations,
          setSelectedToStations
        )} */}

        {renderCheckboxList(
          "Direction",
          availableDirection,
          selectedDirection,
          setSelectedDirection
        )}
        {renderCheckboxList(
          "Department",
          availableDepartments,
          selectedDepartments,
          setSelectedDepartments,
          [
            {
              setFunc: setSelectedTypes,
              getValidOptions: (departments) =>
                new Set(
                  data?.Type.filter((t) =>
                    departments.has(t.Department)
                  ).flatMap((t) => t.data)
                ),
            },
          ]
        )}
        {renderCheckboxList(
          "Type",
          availableTypes,
          selectedTypes,
          setSelectedTypes,
          [
            {
              setFunc: setSelectedBlockTypes,
              getValidOptions: (types) =>
                new Set(
                  data?.Block_Type.filter(
                    (bt) => types.has(bt.Block_type) || bt.Block_type === ""
                  ).flatMap((bt) => bt.Data)
                ),
            },
          ]
        )}
        {renderCheckboxList(
          "Month",
          availableMonths,
          selectedMonths,
          setSelectedMonths
        )}
        {renderCheckboxList(
          "Block Type",
          availableBlockTypes,
          selectedBlockTypes,
          setSelectedBlockTypes
        )}

        {renderCheckboxList(
          "Granted/Not",
          availableGrantedNot,
          selectedGrantedNot,
          setSelectedGrantedNot
        )}
        {renderCheckboxList(
          "Availed/Not",
          availableAvailedNot,
          selectedAvailedNot,
          setSelectedAvailedNot
        )}
        {renderCheckboxList(
          "Burst",
          availableBurst,
          selectedBurst,
          setSelectedBurst
        )}
        {renderCheckboxList(
          "Corridor",
          availableCorridor,
          selectedCorridor,
          setSelectedCorridor
        )}

        <OverlayTrigger
          delay={{ show: 100, hide: 200 }}
          overlay={<Tooltip id="tooltip-reset">Reset Filter</Tooltip>}
        >
          <div
            className="btn btn-sm btn-danger flex justify-center items-center mt-1 mb-1"
            style={{
              maxWidth: "35px",
              boxShadow: "3px 3px 10px rgba(52, 80, 142, 0.5)",
            }}
            onClick={defaultSetup}
          >
            <RiResetLeftLine style={{ fontSize: "15px", fontWeight: "bold" }} />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default BlockController;
